import {useTranslation} from "react-i18next";
import "./Blog.css"
import {Card} from "react-bootstrap";
import {Link} from "react-router-dom";
import {DateTime} from "luxon";
import {blogsData, useData} from "../../components/hooks/recoilData";
import {useRecoilState} from "recoil";
import useAnimation from "../../utils/hooks/animate";
import {useEffect} from "react";

export const Blogs = () => {
    const {t} = useTranslation();
    useAnimation();
    useEffect(() => {
        document.title = t("title", {name: t("blogs")});
    }, [t]);

    const [updateBlogs] = useData();
    updateBlogs();
    const [blogs,] = useRecoilState(blogsData);

    /*
        useEffect(() => {
            fetch('/blog/data.json')
                .then(response => {
                    if (!response.ok)
                        throw new Error('Network response was not ok');
                    return response.json();
                })
                .then(data => {
                    let dataV = data as DataBlog[];
                    dataV.sort((a, b) => b.date - a.date/!*b.date.localeCompare(a.date)*!/);
                    setBlogs(dataV);
                })
                .catch(error => console.error('Error fetching data:', error));
        }, []);
    */

    return (
        <main className="pt-2">
            <section>
                {blogs.map((blog, id) => (
                    <Link key={id}
                          to={`/blog/${blog.link}`}
                          className="blog-normal-text"
                    >
                        <Card>
                            {/*<Card.Header>{blog.title}</Card.Header>*/}
                            {/*<Card.Img variant="top" src="holder.js/100px180" />*/}
                            <Card.Body>
                                <Card.Title>{blog.title}</Card.Title>
                                <Card.Subtitle className="mb-2 text-muted">{DateTime.fromMillis(blog.date).toFormat('HH.mm dd.MM.yyyy')}</Card.Subtitle>
                                <Card.Text as="div">
                                    <div dangerouslySetInnerHTML={{__html: blog.description}}/>
                                </Card.Text>
                                {/*<Card.Link href={"#/blog/" + blog.id}>Card Link</Card.Link>*/}
                            </Card.Body>
                        </Card>
                    </Link>
                ))}
            </section>
        </main>
    );
};